function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 10,
  fill: "transparent"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6226 3.92407H6.37695C6.23047 3.92609 6.09055 3.98518 5.98696 4.08877C5.88338 4.19236 5.82429 4.33228 5.82227 4.47876V15.5213C5.82429 15.6677 5.88338 15.8077 5.98696 15.9112C6.09055 16.0148 6.23047 16.0739 6.37695 16.0759H13.6226C13.7696 16.0755 13.9104 16.017 14.0143 15.913C14.1183 15.8091 14.1769 15.6682 14.1773 15.5213V4.47876C14.1752 4.33228 14.1162 4.19236 14.0126 4.08877C13.909 3.98518 13.7691 3.92609 13.6226 3.92407ZM6.93164 5.03345H13.0679V14.9666H6.93164V5.03345Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9.60759 12.4934C9.71174 12.5973 9.85284 12.6556 9.99993 12.6556C10.147 12.6556 10.2881 12.5973 10.3923 12.4934L12.4688 10.4175C12.571 10.3125 12.6281 10.1718 12.6281 10.0253C12.6281 9.87884 12.571 9.73814 12.4688 9.63313L10.3929 7.55688C10.2879 7.45466 10.1471 7.39746 10.0006 7.39746C9.854 7.39746 9.71323 7.45466 9.60821 7.55688L7.53134 9.63313C7.42921 9.73814 7.37207 9.87884 7.37207 10.0253C7.37207 10.1718 7.42921 10.3125 7.53134 10.4175L9.60759 12.4934ZM11.2917 10.0247L10.0001 11.3169L8.70821 10.0253L10.0001 8.73376L11.2917 10.0247Z",
  fill: "currentColor"
});

var SvgLiveCasino = function SvgLiveCasino(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLiveCasino, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/live_casino.3cea2337.svg";
export { ForwardRef as ReactComponent };